import React from 'react';
import './styles.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-about">
            <h3>ST<span>OA</span>  Consulting</h3>
            <p>Solutions innovantes pour l'ère numérique. Nous transformons les idées en réalité grâce à la technologie de pointe.</p>
            <div className="social-icons">
              <a href="#" className="social-icon">FB</a>
              <a href="#" className="social-icon">TW</a>
              <a href="#" className="social-icon">IG</a>
              <a href="#" className="social-icon">LI</a>
            </div>
          </div>
          
          <div className="footer-links">
            <h3>Liens Rapides</h3>
            <ul>
              <li><a href="#home">Accueil</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#about">À propos</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-services">
            <h3>Nos Services</h3>
            <ul>
              <li><a href="#services">Identité Visuelle</a></li>
              <li><a href="#services">Montage Vidéo Professionnel</a></li>
              <li><a href="#services">Coaching & Formations</a></li>
              <li><a href="#services">Développement Web</a></li>
            </ul>
          </div>
          
          <div className="footer-contact">
            <h3>Contactez-nous</h3>
            <p><i>📧</i>admin@stoa-consult.eu</p>
            <p><i>📞</i> +32 484 68 15 13</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} STOA Consulting. Tous droits réservés.</p>
          <div className="footer-bottom-links">
            <a href="#">Politique de Confidentialité</a>
            <a href="#">Conditions d'Utilisation</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;